export const UK = { blue: '#012169', red: '#C8102E', gold: '#E6A817', white: '#FFFFFF' };

export const PIPELINE_STAGES = [
  { id: 'evaluating', label: 'Evaluating', colour: '#64748b', bg: '#f1f5f9' },
  { id: 'under_offer', label: 'Under Offer', colour: '#d97706', bg: '#fef3c7' },
  { id: 'exchanged', label: 'Exchanged', colour: UK.blue, bg: '#dbeafe' },
  { id: 'completed', label: 'Completed', colour: '#16a34a', bg: '#dcfce7' },
  { id: 'withdrawn', label: 'Withdrawn', colour: '#94a3b8', bg: '#f8fafc' },
] as const;

export const PIPELINE_FILTERS = ['All', 'Buying', 'Selling', 'Active', 'Under Offer', 'Completed', 'Withdrawn'] as const;

export type PipelineFormState = {
  address: string;
  postcode: string;
  pipeline_type: 'buy' | 'sell';
  stage: string;
  asking_price: string;
  offer_price: string;
  agent_name: string;
  agent_phone: string;
  agent_email: string;
  notes: string;
  target_date: string;
  linked_property_id: string;
};

export const DEFAULT_PIPELINE_FORM: PipelineFormState = {
  address: '', postcode: '', pipeline_type: 'buy', stage: 'evaluating',
  asking_price: '', offer_price: '', agent_name: '', agent_phone: '', agent_email: '',
  notes: '', target_date: '', linked_property_id: '',
};

export function pipelineToForm(item: Record<string, any>): PipelineFormState {
  return {
    address: item.address || '',
    postcode: item.postcode || '',
    pipeline_type: item.pipeline_type === 'sell' ? 'sell' : 'buy',
    stage: item.stage || 'evaluating',
    asking_price: item.asking_price != null ? String(item.asking_price) : '',
    offer_price: item.offer_price != null ? String(item.offer_price) : '',
    agent_name: item.agent_name || '',
    agent_phone: item.agent_phone || '',
    agent_email: item.agent_email || '',
    notes: item.notes || '',
    target_date: item.target_date ? String(item.target_date).split('T')[0] : '',
    linked_property_id: item.linked_property_id ? String(item.linked_property_id) : '',
  };
}

export const fmt = (d: string) => d ? new Date(d).toLocaleDateString('en-GB') : '—';
export const fmtMoney = (n: number | null | undefined) => n != null && !Number.isNaN(Number(n)) ? `£${Number(n).toLocaleString()}` : '—';

export function stageMeta(stage: string) {
  return PIPELINE_STAGES.find(s => s.id === stage) || PIPELINE_STAGES[0];
}

export function isActiveDeal(item: any) {
  return item.stage !== 'completed' && item.stage !== 'withdrawn';
}

export function dealAccent(item: any): string {
  if (item.stage === 'withdrawn') return '#94a3b8';
  if (item.stage === 'completed') return '#16a34a';
  if (item.stage === 'exchanged') return UK.blue;
  if (item.stage === 'under_offer') return UK.gold;
  return item.pipeline_type === 'sell' ? '#0d9488' : '#2563eb';
}
